import { RoutesComponents } from "@/components/app/RoutesComponents";
import { Suspense } from "react";
import { InfoBar } from "components/alerts/InfoBar";
import { PortableVideo } from "components/UI/PortableVideo";
import { useLessNavigation } from "@/common/hooks/useLessNavigation";
import "./AppContent.scss";

export const AppContent = () => {
  const { canShow } = useLessNavigation();

  return (
    <div className="Wrapper">
      <div className="routeWrapper">
        <Suspense>{canShow && <InfoBar />}</Suspense>
        <PortableVideo />
        <RoutesComponents />
      </div>
    </div>
  );
};
